import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

const DeeplinkHandler = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const loc_id = urlParams.get('loc_id');

    if (!loc_id) return;

    // Generate or retrieve device_id
    let device_id = localStorage.getItem('device_id');
    if (!device_id) {
      device_id = uuidv4();
      localStorage.setItem('device_id', device_id);
    }

    // Detect platform
    const platform = /android/i.test(navigator.userAgent)
      ? 'android'
      : /iphone|ipad|ipod/i.test(navigator.userAgent)
      ? 'ios'
      : 'web';

    // Send to backend
    fetch('https://yourapi.com/api/app-installed', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        loc_id,
        platform,
        device_id
      })
    });
  }, []);

  return <div>Welcome! Loading...</div>;
};

export default DeeplinkHandler;
